import gql from 'graphql-tag';

// Creation
export { CREATE_SERVICE_RUN } from './CREATE_SERVICE_RUN';

// Normal modify mutation
export { default as MODIFY_SERVICE_RUN } from './MODIFY_SERVICE_RUN';

// Custom mutations
export { default as ADD_MACHINE_TO_SERVICE_RUN } from './ADD_MACHINE_TO_SERVICE_RUN';
export { default as REMOVE_MACHINE_FROM_SERVICE_RUN } from './REMOVE_MACHINE_FROM_SERVICE_RUN';
export { default as REMOVE_MACHINE_FROM_SERVICE_RUN_DAILY } from './REMOVE_MACHINE_FROM_SERVICE_RUN_DAILY';
export { default as DESTROY_SERVICE_RUN } from './DESTROY_SERVICE_RUN';
export { default as CHANGE_SERVICE_RUN_MACHINES } from './CHANGE_SERVICE_RUN_MACHINES';
export { default as MANUAL_RESTOCK } from './MANUAL_RESTOCK';
export { default as ACKNOWLEDGE_SERVICE_RUN_BRIEF } from './ACKNOWLEDGE_SERVICE_RUN_BRIEF';
export { default as CONFIRM_MY_DAY_STEP } from './CONFIRM_MY_DAY_STEP';
export { default as MAKE_SERVICE_DOCKET_NEXT_STOP } from './MAKE_SERVICE_DOCKET_NEXT_STOP';
export { default as MAKE_SERVICE_DOCKETS_NEXT_STOPS } from './MAKE_SERVICE_DOCKETS_NEXT_STOPS';

// Daily
export { default as DAILY_FRAGMENT } from './DAILY_FRAGMENT';
export { default as GET_SERVICE_RUNS_DAILY } from './GET_SERVICE_RUNS_DAILY';
export { default as DAILY_SUMMARY_FRAGMENT } from './DAILY_SUMMARY_FRAGMENT';
export { default as DAILY_BRIEF_FRAGMENT } from './DAILY_BRIEF_FRAGMENT';
export { default as DAILY_DEBRIEF_FRAGMENT } from './DAILY_DEBRIEF_FRAGMENT';
export { default as DAILY_BRIEF_METRICS_FRAGMENT } from './DAILY_BRIEF_METRICS_FRAGMENT';
export { default as DAILY_COMPACT_FRAGMENT } from './DAILY_COMPACT_FRAGMENT';
export { default as DAILY_EXPANDED_FRAGMENT } from './DAILY_EXPANDED_FRAGMENT';
export { default as GET_SERVICE_RUNS_DAILY_SUMMARY } from './GET_SERVICE_RUNS_DAILY_SUMMARY';
export { default as GET_SERVICE_RUNS_DAILY_BRIEF } from './GET_SERVICE_RUNS_DAILY_BRIEF';
export { default as GET_SERVICE_RUNS_DAILY_DEBRIEF } from './GET_SERVICE_RUNS_DAILY_DEBRIEF';
export { default as GET_SERVICE_RUNS_DAILY_BRIEF_METRICS } from './GET_SERVICE_RUNS_DAILY_BRIEF_METRICS';
export { default as GET_SERVICE_RUN_DAILY_COMPACT } from './GET_SERVICE_RUN_DAILY_COMPACT';
export { default as GET_SERVICE_RUN_DAILY_EXPANDED } from './GET_SERVICE_RUN_DAILY_EXPANDED';
export { default as GET_SERVICE_RUNS_DAILY_COMPACT } from './GET_SERVICE_RUNS_DAILY_COMPACT';
export { default as GET_SERVICE_RUNS_DAILY_EXPANDED } from './GET_SERVICE_RUNS_DAILY_EXPANDED';
export { default as GET_SERVICE_RUNS_DAILY_PICKLIST } from './GET_SERVICE_RUNS_DAILY_PICKLIST';
export { default as GET_SERVICE_RUNS_DAILY_LABELS } from './GET_SERVICE_RUNS_DAILY_LABELS';
export { default as GET_SERVICE_RUNS_MY_DAY_PREVIEW } from './GET_SERVICE_RUNS_MY_DAY_PREVIEW';

// Status and associated fragments
export { default as STATUS_DOCKETS_FRAGMENT } from './STATUS_DOCKETS_FRAGMENT';
export { default as STATUS_FRAGMENT } from './STATUS_FRAGMENT';
export { default as GET_SERVICE_RUN } from './GET_SERVICE_RUN';
export { default as GET_SERVICE_RUN_RECONCILIATION_INSIGHTS } from './GET_SERVICE_RUN_RECONCILIATION_INSIGHTS';
export { default as GET_SERVICE_RUN_ROSTER_DRIVERS } from './GET_SERVICE_RUN_ROSTER_DRIVERS';
export { default as GET_SERVICE_RUN_ROSTER_PICKERS } from './GET_SERVICE_RUN_ROSTER_PICKERS';


export { GET_SERVICE_RUN_WITH_PICKLISTS } from './GET_SERVICE_RUN_WITH_PICKLISTS';
export { RECALCULATE_SERVICE_RUN_PICKLISTS } from './RECALCULATE_SERVICE_RUN_PICKLISTS';
export { MODIFY_SERVICE_RUN_WAREHOUSE } from './MODIFY_SERVICE_RUN_WAREHOUSE';

export const MODIFY_TOTAL_COLLECTED_VALUES = gql`
	mutation modifyTotalCollected(
		$serviceRunId: ID!,
		$values: TotalCollectedValues,
	) {
		modifyTotalCollected(
			serviceRunId: $serviceRunId
			values: $values
		) {
			id
			notesCollected
			coinsCollected
			cashReconciliationStatus
			collectedVariance
		}
	}
`;
